"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Convenience class to use as a binary carrier.
 *
 * Any valid Object with a field named `buffer` may be used as a binary carrier;
 * this class is only one such type of object that can be used.
 */

var BinaryCarrier =
/** @class */
function () {
  function BinaryCarrier(buffer) {
    this.buffer = buffer;
  }

  return BinaryCarrier;
}();

exports.default = BinaryCarrier;